import { Heading } from '@tq/ui-components';
import { useTranslation } from 'react-i18next';

export const BoundaryHeading: React.FC = () => {
  const { t } = useTranslation('case_details_map');

  return (
    <Heading size='md' mb={4}>
      {t('site_boundary', 'Site boundary')}
    </Heading>
  );
};
